import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <div className='footer'>
        <hr />
        <p>Портал для архива актов и ревизий. Только для внутреннего использования</p>
    </div>
  )
}

export default Footer
